


import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Carousel } from 'react-bootstrap';
import Rightcontainer from '../Components/Rightcontainer';
import Downloadbutton from '../Components/Downloadbutton';
import DownloadPopup from '../Components/DownloadPopup';
import Header from '../Components/Header';
import { LanguageContext } from '../Components/LanguageContext';
import { Sparkles, MessageCircle, Gamepad2, Radio } from 'lucide-react';
import 'bootstrap/dist/css/bootstrap.min.css';
// import './Landing.css';

export default function Landing({ userAllData }) {
  const [showDownloadPopup, setShowDownloadPopup] = useState(true);
  const { language } = useContext(LanguageContext);

  const siteSettingRaw = localStorage.getItem('sitSetting');
  let siteSetting = {};
  try {
    siteSetting = siteSettingRaw && siteSettingRaw !== 'undefined' ? JSON.parse(siteSettingRaw) : {};
  } catch (e) {
    siteSetting = {};
  }

  const translations = {
    hi: { Tournaments: 'प्रतियोगिता', playNow: 'अभी खेलें', support: 'सपोर्ट' },
    en: { Tournaments: 'Tournaments', playNow: 'Play Now', support: 'Support' },
  };

  const t = translations[language] || translations.en;

  return (
    <>
      {/* {showDownloadPopup && <DownloadPopup onClose={() => setShowDownloadPopup(false)} />} */}

      <div className="landing-page-wrapper leftContainer mb_space mt-5 pt-5">
        {/* Ambient background light blurs */}
        <div className="landing-ambient-glow glow-1"></div>
        <div className="landing-ambient-glow glow-2"></div>

        <div className="landing-main-container">

          {/* ANNOUNCEMENT MESSAGE BANNER */}
          {siteSetting?.site_message && (
            <div className="announcement-card animate-fade-down">
              <div className="announcement-content">
                <Sparkles className="sparkle-icon" size={18} />
                <span>{siteSetting.site_message}</span>
              </div>
            </div>
          )}
 <div className="landing_page_slider">
                  <Carousel interval={2000} pause="hover" controls={false}
                    indicators={false}>
                    {" "}

                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src="./images/slider1.png"
                        alt="Second slide"
                      />
                    </Carousel.Item>
                    <Carousel.Item>
                      <img
                        className="d-block w-100"
                        src="./images/slider2.png"
                        alt="First slide"
                      />
                    </Carousel.Item>
                   
                  </Carousel>
                </div>
          {/* GAMES SELECTION GRID */}
          <section className="games-section-wrapper">
            <div className="games-section-header">
              <h3 className="section-title">
                <Gamepad2 size={22} className="title-icon" /> Featured Games
              </h3>
            </div>

            <div className="games-grid-container">
              {/* LUDO CLASSIC MANUAL CARD */}
              <Link to="/Homepage/ludoClassicManual" className="game-card-link">
                <div className="game-card-box">
                  <div className="live-status-pill">
                    <Radio size={12} className="pulse-radio" />
                    <span>LIVE</span>
                  </div>
                  <div className="game-card-img-wrap">
                    <img
                      src="./mainimage/ludoclassic.png"
                      alt="Ludo Classic"
                      className="game-cover-img"
                    />
                  </div>
                  <div className="card-hover-overlay">
                    <span className="play-btn-pill">{t.playNow}</span>
                  </div>
                </div>
              </Link>

              {/* LUDO WHATSAPP SUPPORT CARD */}
              {siteSetting?.whatsappSupport && (
                <a
                  href={siteSetting?.whatsappSupport}
                  target="_blank"
                  rel="noreferrer"
                  className="game-card-link"
                >
                  <div className="game-card-box support-card-variant">
                    <div className="live-status-pill red-live">
                      <Radio size={12} className="pulse-radio" />
                      <span>LIVE</span>
                    </div>
                    <div className="game-card-img-wrap">
                      <img
                        src="./mainimage/ludosupport.png"
                        alt="Ludo Support"
                        className="game-cover-img"
                      />
                    </div>
                    <div className="card-hover-overlay">
                      <span className="play-btn-pill gold">{t.support}</span>
                    </div>
                  </div>
                </a>
              )}
            </div>
          </section>

          {/* DOWNLOAD APP BUTTON SECTION */}
          <div className="download-button-wrapper">
            <Downloadbutton />
          </div>

        </div>
      </div>

      {/* WHATSAPP SUPPORT FLOATING ACTION */}
      {siteSetting?.whatsappSupport && (
        <div className="floating-social-btn whatsapp-floating">
          <a href={siteSetting.whatsappSupport} target="_blank" rel="noreferrer">
            {/* Can optionally display floating whatsapp icon here */}
          </a>
        </div>
      )}

      {/* WHATSAPP CHANNEL JOIN BUTTON */}
      {/* <a
        href="https://whatsapp.com/channel/0029Vb8PwCwHrDZnj7lWU62q"
        target="_blank"
        rel="noreferrer"
        className="join-channel-btn pulse-glow-btn"
      >
        <MessageCircle size={18} />
        <span>🎁 Join Channel</span>
      </a> */}

      {/* RIGHT SIDEBAR ON DESKTOP */}
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </>
  );
}